import { Link } from "react-router-dom";

function TopicsBox(props) {
    return (
        <div className="topics">
            {[...props.topics].map((topic, idx) => {
                return (
                    <Link to={"/topics/"+topic} key={idx} className="article-content topic" >
                        {topic}
                    </Link>
                );
            })}
        </div>
    );
  }
  
export default TopicsBox;
